import { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { TUserAuthInfo } from '../../redux/types';
import { setAuthData } from '../../redux/slices/authSlice';

const useLoadUser = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isFirstTimeUser, setIsFirstTimeUser] = useState(true);
  const authData = useAppSelector((state) => state.auth);

  useEffect(() => {
    const authString = localStorage.getItem('AUTH_USER_DATA');

    if (authString) {
      const storedAuthData = JSON.parse(authString) as {
        accessToken: string;
        currentUser: TUserAuthInfo;
      };

      // If auth data exists in localStorage but Redux is not set, dispatch to Redux
      if (!authData || !authData.accessToken) {
        dispatch(setAuthData(storedAuthData));
        setIsFirstTimeUser(
          storedAuthData.currentUser?.patientPlatformFirstLogin
        );
      }
    }

    setIsLoading(false);
  }, [dispatch, authData]);

  // Sync Redux state changes to localStorage
  useEffect(() => {
    if (authData && authData.accessToken) {
      localStorage.setItem('AUTH_USER_DATA', JSON.stringify(authData));
    }
  }, [authData]);

  return { isLoading, isFirstTimeUser };
};

export default useLoadUser;
